var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
let IpProtect = class IpProtect extends LitElement {
    constructor() {
        super(...arguments);
        this.onContext = (e) => {
            const t = e.target;
            if (t.matches("input, textarea, [contenteditable]"))
                return;
            if (t.closest(".chart, .feedback")) {
                e.preventDefault();
                return;
            }
            if (t.closest(".chart"))
                e.preventDefault();
        };
        this.onKey = (e) => {
            const focused = document.activeElement;
            if (focused?.matches("input, textarea, [contenteditable]"))
                return;
            const k = e.key.toLowerCase();
            if ((e.metaKey || e.ctrlKey) && ["c", "x", "a", "p", "s"].includes(k)) {
                e.preventDefault();
            }
        };
        this.onVisibility = () => {
            document.querySelectorAll(".chart").forEach((el) => {
                el.style.filter = document.hidden ? "blur(8px)" : "";
            });
        };
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("contextmenu", this.onContext);
        document.addEventListener("keydown", this.onKey);
        document.addEventListener("visibilitychange", this.onVisibility);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("contextmenu", this.onContext);
        document.removeEventListener("keydown", this.onKey);
        document.removeEventListener("visibilitychange", this.onVisibility);
    }
    render() {
        return html ``;
    }
};
IpProtect = __decorate([
    customElement("ip-protect")
], IpProtect);
export { IpProtect };
